module.exports = __webpack_public_path__ + "img/chongdianzhuang.98d7b0e6.png";